import React from 'react';
import { byCard, byCountry } from 'utils';
import {
  PRODUCT_CODE_AFS,
  PRODUCT_CODE_AU_GEM,
  PRODUCT_CODE_DAVID_JONES_PREMIERE,
  PRODUCT_CODE_DAVID_JONES_PRESTIGE,
  PRODUCT_CODE_GO,
  PRODUCT_CODE_LOW_RATE,
  PRODUCT_CODE_NZ_GEM,
  PRODUCT_CODE_TWENTY_EIGHT_DEGREES,
} from '_config';
import { DavidJonesFooter } from '../david-jones/Footer';
import { AuFooter } from './AuFooter';
import { NZV2Footer } from './NZV2Footer';

export function Footer(props) {
  const ProductFooter = byCard({
    [PRODUCT_CODE_NZ_GEM]: NZV2Footer,
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: DavidJonesFooter,
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: DavidJonesFooter,
    [PRODUCT_CODE_TWENTY_EIGHT_DEGREES]: AuFooter,
    [PRODUCT_CODE_GO]: AuFooter,
    [PRODUCT_CODE_AU_GEM]: AuFooter,
    [PRODUCT_CODE_AFS]: AuFooter,
    [PRODUCT_CODE_LOW_RATE]: AuFooter,
    default: byCountry({ NZ: NZV2Footer, AU: DavidJonesFooter }),
  });

  return <ProductFooter {...props} />;
}
